import { CsvMapper } from '@acme/core'
import { match } from 'oxide.ts'
import {
    CreateCentroCustoOutput as CentroCusto,
    centroCusto_v2,
} from 'service/api'
import { toast } from 'sonner'
import { useStore } from 'store'

import ModalImportar from 'global/components/ImportModal'
import { hasPermission } from 'hooks/useBackendMenu'
import { mapearArvore } from '../../mapArvore'

class CentroCustoMapper extends CsvMapper<
    Omit<CentroCusto & { id: number }, 'empresaId'>
> {}

export default function ImportarCentroCusto() {
    const empresaId = useStore(state => state.companyId)

    function handleDecodedCsv(dados: string): any {
        const mapper = CentroCustoMapper.from(
            dados,
            ({ CsvString, CsvNumber }) => ({
                id: CsvNumber,
                codigo: CsvString,
                nomeCentroCusto: CsvString,
                predecessorId: CsvNumber,
            }),
        )

        return match(mapper, {
            Ok: dados =>
                mapearArvore(
                    dados
                        .toPlain({
                            emptyStringToNull: true,
                            zeroToNull: true,
                        })
                        .map(dado => ({
                            ...dado,
                            empresaId,
                        })) as any,
                ),
            Err: erro => {
                toast.error(erro.message)
                throw erro
            },
        })
    }

    return hasPermission(['create', 'CentrosDeCusto']) ? (
        <ModalImportar
            api={centroCusto_v2}
            name="Centros de custo"
            onDecodedCsv={handleDecodedCsv}
        />
    ) : null
}
